import type { TAppDispatch, TRootState } from 'core/store/store';

interface IStoreAccessor {
  getState: () => TRootState;
  dispatch: TAppDispatch;
}

let storeAccessor: IStoreAccessor | null = null;

export const setStoreAccessor = (accessor: IStoreAccessor) => {
  storeAccessor = accessor;
};

export const getStoreAccessor = () => {
  if (!storeAccessor) {
    throw new Error('Store accessor not initialized. Call setStoreAccessor first.');
  }
  return storeAccessor;
};
